import { render } from "./Idle_2.vue?vue&type=template&id=85e2b4d8&scoped=true"
import script from "./Idle_2.vue?vue&type=script&lang=js"
export * from "./Idle_2.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=85e2b4d8&scoped=true&lang=css"
import "@/assets/css/user/pages/intro.css?vue&type=style&index=1&id=85e2b4d8&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=2&id=85e2b4d8&scoped=true&lang=css"
import "@/assets/css/user/dark/intro-dark.css?vue&type=style&index=3&id=85e2b4d8&scoped=true&lang=css"
import "@/../node_modules/swiper/swiper.css?vue&type=style&index=4&id=85e2b4d8&scoped=true&lang=css"
import "@/../node_modules/swiper/modules/autoplay/autoplay.min.css?vue&type=style&index=5&id=85e2b4d8&scoped=true&lang=css"
import "./Idle_2.vue?vue&type=style&index=6&id=85e2b4d8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e2b4d8"]])

export default __exports__